import { NgModule } from '@angular/core';
import { ReferencesShowRoutingModule } from '@app/protected/references/show/references.show-routing.module';
import { ReferencesShowComponent } from '@app/protected/references/show/references.show.component';
import { AppSharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [ReferencesShowComponent],
  imports: [AppSharedModule, ReferencesShowRoutingModule]
})
export class ReferencesShowModule {}
